<template>
  <div class="zj-emergencyIncident-infopanel">
    <el-row type="flex" justify="space-between">
      <el-col class="seq" :span="2">
        <div>{{info.index + 1}}</div>
      </el-col>
      <el-col :span="22" class="zj-emergencyIncident-infopanel-detail">
        <el-row type="flex" justify="space-between">
          <label class="name">事件名称：{{info.eventName}}</label>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="6">
            <el-row>
              <label>应急用时:</label>
              <label class="contact">{{info.emergencyWhen}}</label>
            </el-row>
            <el-row>
              <label>事件类型:</label>
              <label class="contact">{{eventTypeName}}</label>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <label>接报时间:</label>
              <label class="contact">{{info.eventDate}}</label>
            </el-row>
            <el-row>
              <label>事件等级:</label>
              <label class="contact">{{eventLevelName}}</label>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <label>报送人:</label>
              <label class="contact">{{info.contact}}</label>
              <label class="contact">{{info.phone}}</label>
            </el-row>
            <el-row></el-row>
          </el-col>
          <el-col class="detail-list-btn-col" :span="6">
            <el-button @click.stop="showinventoryList" class="detail-list-btn">进入应急作战指挥</el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-row>
              <label>事发地点:</label>
              <label>{{info.address}}</label>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "ZJComponent-InfoPanel",
  props: {
    info: {
      index: Number,
      id: String,
      executId: String,
      eventName:String,
      emergencyWhen: String,
      eventDate: String,
      contact: String,
      phone: String,
      eventType: String,
      eventLevel: String,
      address: String,
      ConfirmEventType:String,
      ConfirmEventLevel:String
    },
    FitEventTypeDic:Array,
    EventLevelDic:Array,
    type: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      eventTypeName:"",
      eventLevelName:""
    };
  },
  created:function(){
    let eventType=this.info.ConfirmEventType;
    let eventLevel=this.info.ConfirmEventLevel;
    this.eventTypeName=this.FitEventTypeDic[eventType];
    this.eventLevelName=this.EventLevelDic[eventLevel];
  },
  methods: {
    showinventoryList() {
      this.$router.push({
        path: "/plugin/emergency/ui/EmergencyOperations",
        query: {
          ExecutId: this.info.executId
        }
      });
    }
  }
};
</script>

<style>
</style>